module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-validate.validate-campaign')))]), _c('p', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-validate.description')))]), _c('form', {
    staticClass: "campaign-info",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 validate-input"
  }, [_c('form-input', {
    attrs: {
      "name": "campaign_code",
      "label": _vm.$t("pos.campaign-validate.insert-campaign-code"),
      "placeholder": _vm.$t("campaign_field.title.code")
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pos.campaign-validate.dont-know-campaign-code')))]), _c('p', [_vm._v(_vm._s(_vm.$t('pos.campaign-validate.search-in-the-list-of-campaigns')))]), _c('b-btn', {
    staticClass: "text-success",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-validate.or-export-campaigns')))])], 1), _c('gotu-nav-button', {
    staticClass: "mt-5",
    attrs: {
      "type": "submit",
      "theme": "default-cta",
      "disabled": !_vm.code,
      "loading": _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.proceed')))])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e6f3d4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/campaign-validate/CampaignValidate.vue
// module id = 2046
// module chunks = 1